// extracted by mini-css-extract-plugin
export default {"title":"NewPresentationComponentPopup_title__LQAAC","iconEdit":"NewPresentationComponentPopup_iconEdit__Z81LE","explanation":"NewPresentationComponentPopup_explanation__tR4IX"};